import { FaBullseye } from "react-icons/fa";

import Stat from "../../components/Stat";

export default function DroneAccuracyStat({
    offline,
    sleeping,
    droneStatus,
    accuracy,
    forAdmin,
}) {
    const makeResult = (status, cls) => ({
        text: (
            <span className={!offline && !sleeping ? cls : "text-secondary"}>
                {status}
            </span>
        ),
        className: cls,
    });

    let result;

    if (accuracy < 0) {
        result = makeResult("Invalid", "text-danger");
    } else if (forAdmin) {
        if (accuracy < 0.5) {
            result = makeResult(`${accuracy}m`, "text-success");
        } else if (accuracy < 1.0) {
            result = makeResult(`${accuracy}m`, "text-warning");
        } else if (accuracy >= 10.0) {
            result = makeResult("∞", "text-danger");
        } else {
            result = makeResult(`${accuracy}m`, "text-danger");
        }
    } else {
        // User view
        if (sleeping) {
            result = makeResult("Sleeping", "text-secondary");
        } else if (droneStatus === "Checking position") {
            result = makeResult("Checking position", "text-success");
        } else if (accuracy < 0.5) {
            result = makeResult("Accurate", "text-success");
        } else {
            result = makeResult("Inaccurate", "text-danger");
        }
    }

    const icon = (
        <FaBullseye
            className={`ms-2 ${!offline && !sleeping ? result.className : "text-secondary"}`}
            style={{ marginTop: "-2px", color: "#b9b9b9" }}
        />
    );

    return <Stat label="Accuracy" text={result.text} icon={icon} />;
}
